var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ETCRM_URL } from "@/utils/const";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import FooterStart from "./footerStart";
import FooterCenter from "./footerCenter";
import FooterEnd from "./footerEnd";
export function FooterLarge(_a) {
    var data = _a.data;
    var t = useTranslation(["common"]).t;
    return (_jsxs("div", __assign({ className: "flex flex-row flex-auto h-full" }, { children: [_jsx("div", __assign({ className: "navbar-brand flex flex-none w-[16rem] justify-center items-center cursor-pointer bg-[var(--colors-footer-logo)]" }, { children: _jsx(Link, __assign({ to: "/" }, { children: _jsx("img", { src: "".concat(ETCRM_URL, "/").concat(data === null || data === void 0 ? void 0 : data.logo), alt: t("app.LBL_COMPANY_LOGO", { ns: "common" }) }) })) })), _jsxs("div", __assign({ className: "flex flex-row flex-auto overflow-x-auto overflow-y-hidden h-full bg-[color:var(--colors-footer-bg border-solid border-t-1 border-t-[var(--colors-layout-separator)] bg-[var(--colors-footer)]" }, { children: [_jsx(FooterStart, {}), _jsx(FooterCenter, {}), _jsx(FooterEnd, {})] })), _jsx("div", __assign({ className: "flex flex-none w-[16rem] justify-center items-center cursor-pointer bg-[var(--colors-footer-settings)]" }, { children: "TECHNICAL" }))] })));
}
